import { APICore } from './apiCore';

const api = new APICore();

export function settingsAppAdd(data: any) {
    return api.create('/settings/app/add', data);
}

export function settingsAppList(data: any) {
    return api.get('/settings/app/list', data);
}

export function settingsAppUpdateForce(data: any) {
    return api.update('/settings/app/update/force', data);
}

export function settingsAppDelete(data: any) {
    return api.delete('/settings/app/delete', data);
}
